import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

const OPTIONS = [
  { mode: "dark", label: "Dark", icon: Moon },
  { mode: "light", label: "Light", icon: Sun },
  { mode: "system", label: "System", icon: Monitor },
];

export const ThemeToggle = ({ withLabels = false, className = "" }) => {
  const { mode, setMode } = useTheme();
  return (
    <div
      data-testid="theme-toggle"
      role="group"
      aria-label="Colour theme"
      className={`inline-flex items-center gap-0.5 rounded-full border border-zinc-800 bg-zinc-900/60 p-0.5 ${className}`}
    >
      {OPTIONS.map(({ mode: m, label, icon: Icon }) => (
        <button
          key={m}
          type="button"
          data-testid={`theme-option-${m}`}
          aria-pressed={mode === m}
          title={`${label} mode`}
          onClick={() => setMode(m)}
          className={`inline-flex items-center gap-1.5 rounded-full px-2.5 h-8 text-xs font-medium transition-colors ${
            mode === m ? "bg-indigo-500 text-white" : "text-zinc-400 hover:text-zinc-200"
          }`}
        >
          <Icon className="w-3.5 h-3.5" />
          {withLabels && <span>{label}</span>}
        </button>
      ))}
    </div>
  );
};

export default ThemeToggle;
